import React, { useContext, useEffect, useState } from 'react'
import { PaymentContext } from '../Context/PaymentContext'
import {withRouter, useHistory, useLocation} from 'react-router-dom'
import Header from '../Components/Header/Header'
import Loading from '../Components/Loading/Loading'
import Modal from 'react-modal'
import Footer from '../Components/Footer/Footer'

const GuestDataCapture = (props) => {
    const history = useHistory()
    const location = useLocation();

    const { setUserInfo, darkMode } = useContext(PaymentContext)
    const [darkModeStyle, setDarkModeStyle] = useState({
        globalContainer: 'global_container',
        buttonStyle: 'submitBtn',
        color: '#585858'

    })
    // const [dataUser,setDataUser] = useState(JSON.parse(localStorage.getItem("Live")))
    const [name,setName] =  useState(window.localStorage.getItem("fullname"))
    const [phone,setPhone] =  useState(window.localStorage.getItem("phone"))
    const [lot,setLot] =  useState("")
    const [lotTitle,setLotTitle] =  useState("")
    const [isLoading,setIsLoading] =  useState(true)
    const [showModal,setShowModal] =  useState(false)
    const [showNoLotModal,setShowNoLotModal] =  useState(true)
    const [showErrorModal,setShowErrorModal] =  useState(false)
    const [showLotNotAvailable,setShowLotNotAvailable] =  useState(false)
    const [description,setDescription] =  useState('')

    const [license, setLicense] = useState({
        lp: window.localStorage.getItem("license")
    })

    const changeTxt = (e) => {
        setLicense({...license, 'lp': e.target.value.split(' ').join('')})
        window.localStorage.setItem('license', e.target.value.split(' ').join(''))

    }

    const changeTxtName = (e) => {
        setName(e.target.value)
        window.localStorage.setItem('fullname', e.target.value)

    }

    const changeTxtPhone = (e) => {
        setPhone(e.target.value)
        window.localStorage.setItem('phone', e.target.value)

    }

    useEffect(() => {     
        // localStorage.clear();
        // localStorage.setItem("lotTime","{\"Mon_fri_day_h\":0,\"Mon_fri_eve_h\":0,\"Mon_fri_day_m\":0,\"Mon_fri_eve_m\":0,\"Week_day_h\":0,\"Week_day_m\":6,\"Week_eve_h\":2,\"Week_eve_m\":6}")
        window.localStorage.setItem('backbutton', false)
        if (darkMode >= 1800 || darkMode <= 600) {
            setDarkModeStyle({
                globalContainer: 'global_container_dark',
                buttonStyle: 'submitBtn_dark',
                color: 'white'

            })
        }
        window.localStorage.removeItem('lot')
        window.localStorage.removeItem('lotTitle')
        const getLot = location.search.slice(1).split("&")[0].split("=")[1];
        if(getLot && getLot!==null && getLot!==undefined && getLot!=='undefined' && getLot!=='null'){
            setLot(getLot)
            modalGet(getLot)
        }else{
            setIsLoading(false)
            setLot("")
            setShowNoLotModal(true)
        }
    }, [])

    const submitedDataCapture = (e) => {
        e.preventDefault()
        window.localStorage.setItem('fullname', e.target.name.value)
        window.localStorage.setItem('phone', e.target.phone.value)
        window.localStorage.setItem('license', e.target.license.value)
        setUserInfo({
            name: e.target.name.value,
            phone: e.target.phone.value,
            license: e.target.license.value
        })
        // history.push(`/select-payment/`)
    }


    const lotNumber = window.localStorage.getItem('lot')

    const terms_onclick = () => {
        history.push('/terms/')
    }

    const api_data = {
        'fullname': window.localStorage.getItem('fullname'),
        'license_plate': window.localStorage.getItem('license'),
        'set_time': window.localStorage.getItem('startTime'),
        'exp_time': window.localStorage.getItem('expTime'),
        'location_id': window.localStorage.getItem('lot'),
        'phone': window.localStorage.getItem('phone'),
        'token': window.localStorage.getItem('token'),
        'amount': window.localStorage.getItem('totalServer'),
        'expireTime': window.localStorage.getItem('expTimeInSecs'),
        'realTimeServer': window.localStorage.getItem('realTime'),
        'startTime': window.localStorage.getItem('startTime'),
        'count': window.localStorage.getItem('count'),
        'paid': window.localStorage.getItem('total'),
        'previousId': window.localStorage.getItem('guid')
    }


    // const sendDataSuccess = (e)=>{
    //     e.preventDefault()
    //     localStorage.setItem('fullname', e.target.name.value)
    //     localStorage.setItem('phone', e.target.phone.value)
    //     localStorage.setItem('license', e.target.license.value)
    //     setUserInfo({
    //         name: e.target.name.value,
    //         phone: e.target.phone.value,
    //         license: e.target.license.value
    //     })
    //
    //     setIsLoading(true)
    //
    //     try {
    //
    //         if (localStorage.getItem("typePay")===""){
    //
    //             var startTime = localStorage.getItem("endDateTimeStamp")
    //
    //         }else{
    //             var startTime = Date.now()+10000
    //         }
    //
    //     }catch (e){
    //         var startTime = Date.now()+10000
    //
    //     }
    //
    //     fetch(`${process.env.REACT_APP_URL_ONESHOT}/v2/Park/Reserve`, {
    //         method: 'POST',
    //         headers: {"Content-Type": "application/json"},
    //         body: JSON.stringify({
    //             "fullName": api_data.fullname===null  ? name : api_data.fullname,
    //             "phoneNumber": api_data.phone===null ? phone : api_data.phone,
    //             "plateNo": api_data.license_plate===null ? license.lp : api_data.license_plate,
    //             "startDateTimeStamp": startTime,
    //             "duration": api_data.realTimeServer,
    //             "lotId":api_data.location_id,
    //             "PreviousId":api_data.previousId,
    //             "metaData":JSON.stringify({"sec":api_data.expireTime,"start":api_data.startTime,"end":api_data.exp_time,"count":api_data.count,"lot":api_data.location_id}),
    //         }),
    //     }).then((res) => res.json())
    //         .catch((error) => {
    //             alert('Error1:')})
    //         .then((data) => {
    //
    //             if (data.data){
    //
    //                 window.location.replace(data.data.url);
    //
    //                 // callBack(data.data.reqId)
    //
    //             }else {
    //                 alert(data.error.message)
    //                 setIsLoading(false)
    //
    //             }
    //             // alert(data.data.token)
    //             // if(data.status === 400){
    //             //     setNotifications(`Error >>> ${data.message}`)
    //             // }
    //             // else{
    //             //     setNotifications(null)
    //             //     setClientSecret(data.clientSecret)
    //             // }
    //         })
    //
    //
    // }
    const sendDataSuccess =async (e)=>{
        e.preventDefault()
        window.localStorage.setItem('fullname', e.target.name.value)
        window.localStorage.setItem('phone', e.target.phone.value)
        window.localStorage.setItem('license', e.target.license.value)
        setUserInfo({
            name: e.target.name.value,
            phone: e.target.phone.value,
            license: e.target.license.value
        })

        setIsLoading(true)

        const licensePlate2 = api_data.license_plate===null ? license.lp : api_data.license_plate;

        if(lot && lot!=null && lot!==undefined && lot!=='undefined' && lot!=='null'){
            await fetch(`${process.env.REACT_APP_URL_ONESHOT}/v1/Cameras/${lot}/${licensePlate2}`, {
                method: 'GET',
                headers: {"Content-Type": "application/json"},

            }).then((res) => res.json())
                .then((data) => {
                    if(data.data){
                        console.log(data.data.plateWhiteListExpireDate)
                        window.localStorage.setItem("camera",JSON.stringify(data.data))
                        if(data.data.plateWhiteListExpireDate!==null) {
                            history.push('/whitelist/')
                        }else if (data.data.penaltyAmount!==null){
                            window.localStorage.setItem("penaltyAmount",true)
                            history.push('/settime/')
                        }else {
                            window.localStorage.setItem("penaltyAmount",false)
                            history.push('/settime/')
                        }
                    }else{
                        window.localStorage.setItem("camera","{\"penaltyAmount\":null}")
                        window.localStorage.setItem("penaltyAmount",false)
                        history.push('/settime/')
                    }
                })
                .catch((error) => {
                    alert('Error1:')
                })

        }
        setIsLoading(false)

    }


    const callBack = (id) =>{
        fetch(`${process.env.REACT_APP_URL_ONESHOT}/v1/Park/GetDetail?reqId=${id}`, {
            method: 'GET',
            headers: {"Content-Type": "application/json"},

        }).then((res) => res.json())
            .then((data) => {
                if(data.data){
                    var x1 = JSON.parse(data.data.metaData)
                    window.localStorage.setItem("expTime",x1.end)
                    // setTimeout(()=>{
                    if( data.data.diffMinutes < 0){
                        window.localStorage.setItem("count",0)
                        window.localStorage.setItem("expTimeInSecs",0)
                    }else
                    {
                        window.localStorage.setItem("count",x1.count)
                        window.localStorage.setItem("expTimeInSecs",x1.sec)
                    }

                    // },1000)
                    window.localStorage.setItem("startTime",data.data.startDate)
                    window.localStorage.setItem("endTime",data.data.endDate)
                    window.localStorage.setItem("phone",data.data.phoneNumber)
                    window.localStorage.setItem("license",data.data.plateNo)
                    window.localStorage.setItem("fullname",data.data.fullName)
                    // localStorage.setItem("expTime",data.data.endDate)
                    window.localStorage.setItem("total",data.data.price)
                    window.localStorage.setItem("taxPercentage",data.data.taxPercentage)
                    window.localStorage.setItem("transactionFee",data.data.transactionFee)
                    window.localStorage.setItem("realTime",data.data.diffMinutes)
                    window.localStorage.setItem("lotId",x1.lot)
                    window.localStorage.setItem("endDateTimeStamp",data.data.endDateTimeStamp)
                }else{
                    alert('Error on loading GuestDataCapture.GetDetail')
                }
            })
            .catch((error) => {
                alert('Error on fetching GuestDataCapture.GetDetail')
            })

        setTimeout(()=>{
            history.push(`/remaining-time/?id=${id}`)

        },1500)
    }

    const modalGet = async (id) =>{
        setIsLoading(true)
        if(id && id!==null && id!==undefined && id!=='undefined' && id!=='null'){
            await fetch(`${process.env.REACT_APP_URL_ONESHOT}/v1/Park/Get/${id}`, {
                method: 'GET',
                headers: {"Content-Type": "application/json"},
            }).then((res) => res.json())
                .then((data) => {
                    if (data.data && data.data!==undefined){
                        setShowNoLotModal(false)
                        window.localStorage.setItem('lot', id)
                        setLotTitle(id+' - '+data.data.title)
                        window.localStorage.setItem('lotTitle', id+' - '+data.data.title)
                        if(data.data.description!==''){
                            setDescription(data.data.description)
                            setShowModal(true)
                        }
                        if(!data.data.isEnabled){
                            setShowLotNotAvailable(true)
                        }
                    }else if(data.error && data.error!==undefined){
                        setShowNoLotModal(true)
                    }
                }).catch((e)=>{
                    setShowNoLotModal(false)
                    setShowErrorModal(true)
                })
        }else{
            setShowNoLotModal(true)
        }
        setIsLoading(false)
    }

    return (
        <>
		<Header home={true}/>
        <div className={`${darkModeStyle.globalContainer} choose_lot`}>
            <div className='content_holder'>
                {!isLoading && 
                    <>
                        <h1 className='WelcomeHeadder' style={{ textAlign: 'center', color: darkModeStyle.color }}>Welcome to Lot Location<br /> <strong>{lotTitle}</strong></h1>
                        <Modal
                            style={{backgroundColor:'white'}}
                            isOpen={showModal}
                            contentLabel="onRequestClose Example"
                            className="Modal"
                            overlayClassName="Overlay"
                        >
                            <h1 className='WelcomeHeadder' style={{ textAlign: 'center', color: darkModeStyle.color }}>Welcome to Lot Location<br /> <strong>{lotTitle}</strong></h1>
                            <p>------------------------</p>
                            <h5>Notice:</h5>
                            <p style={{textAlign:'left',padding:'5%'}}>{description}</p>
                            <button className='btn_msgModal' onClick={()=>setShowModal(false)}>Close message</button>
                        </Modal>
                        <Modal
                            style={{backgroundColor:'white'}}
                            isOpen={showNoLotModal}
                            contentLabel="on No Lot"
                            className="Modal"
                            overlayClassName="Overlay"
                        >
                            <h1 style={{ textAlign: 'center', color: darkModeStyle.color }}>
                                Not a valid web address
                            </h1>
                            <br/>
                            <h1>
                                Please scan a valid QR code or check web address on sign again
                            </h1>
                        </Modal>
                        <Modal
                            style={{backgroundColor:'white'}}
                            isOpen={showErrorModal}
                            contentLabel="on Error"
                            className="Modal"
                            overlayClassName="Overlay"
                        >
                            <h1 style={{ textAlign: 'center', color: darkModeStyle.color }}>
                                Error on fetching lot information
                            </h1>
                            <br/>
                            <h1>
                                Please try later
                            </h1>
                        </Modal>
                        <Modal
                            style={{backgroundColor:'white'}}
                            isOpen={showLotNotAvailable}
                            contentLabel="on No Lot"
                            className="Modal"
                            overlayClassName="Overlay"
                        >
                            <h1 style={{ textAlign: 'center', color: darkModeStyle.color }}>
                                Lot not available now
                            </h1>
                            <br/>
                            <h1>
                                Please try later
                            </h1>
                        </Modal>

                        {!showModal && !showNoLotModal && !showLotNotAvailable && !showErrorModal && 
                            <form className='form' onSubmit={sendDataSuccess}>
                                <label style={{color: darkModeStyle.color}} className='labels'>License Plate</label>
                                <input
                                    required
                                    name='license'
                                    maxLength="7"
                                    onChange={(e) => {changeTxt(e)}}
                                    value={license.lp}
                                    style={{textTransform: "uppercase"}}
                                    onKeyPress={(event) => {
                                        if (!/[0-9,a-z,A-Z]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                ></input>

                                <label style={{ color: darkModeStyle.color}} className='labels'>Full Name</label>
                                <input name='name' required  value={name} onChange={(e) => {changeTxtName(e)}}></input>
                                <label style={{ color: darkModeStyle.color }} className='labels'>Phone Number</label>
                                <input name='phone' required value={phone} maxLength={10} minLength={10} pattern="\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*" onChange={(e) => {changeTxtPhone(e)}}></input>

                                <input className={darkModeStyle.buttonStyle}  disabled={isLoading} type='submit'></input>
                                <div className='tc_holder'>
                                <button onClick={terms_onclick} className='terms_condition'>Terms & Conditions</button>
                                </div>

                            </form>
                        }
                    </> 
                }
                {isLoading && <Loading/> }
            </div>
        </div>
        <Footer />
        </>
    )
}

export default withRouter(GuestDataCapture);
